export function isSafari(userAgent: string) {
  return (
    /safari/i.test(userAgent) &&
    !/chrome/i.test(userAgent) &&
    !/firefox/i.test(userAgent)
  )
}
